/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useCallback, useEffect, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation} from 'react-i18next'
import axios from 'axios'
import Pagination from '../../component/Pagination'
import {
  getApproval,
  createApproval,
  editApproval,
  deleteApproval,
} from '../../../../api/modules/approvallevel'
import {
  getSectorAll,
  getSalesAreaAll,
  getPaymentAll,
  getProductType,
} from '../../../../api/modules/getdatalist'
import swal from 'sweetalert'
import {getAccessesApprovalKo} from '../../../../api/modules/access/access'
import i18next from 'i18next'
import {Spinner} from 'react-bootstrap'
import CurrencyInput from 'react-currency-input-field'
import CustomUseEffect from '../../masterData/priceList/CustomUseEffect'
import {fetchContractLevels, headers} from '../../../../services/fetcher'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {objToParams} from '../../../../utils/objToParams'
import {RowFilter} from './RowFilter'
import {
  filterSelector,
  resetFilterContractLevel,
  setFilterContractLevel,
  setIsFetchData,
} from '../../../../redux/slices/filterSlices'
import {SelectPageSize} from '../../../../components/SelectPageSize/SelectPageSize'
import * as TableUI from '../../../../components/Table/Table'
import {useRowTable} from '../../../../hooks/useRowTable'
import {StyledCard} from '../../../../components/StyledCard'
import {StyledButtonGroups} from '../../../../components/StyledButtonGroups'
import {appSelector} from '../../../../redux/slices/appSlices'
import {HakAkses} from '../../../../components/mikro/getHakAkses'
import {authSelector} from 'src/redux/slices/authSlices'
import {useLoaderList} from 'src/hooks/useLoaderList'
import {ActionIcon, AppButton} from 'src/components'
import {SkeletonForm} from 'src/components/Skeletons'
import { ButtonExport } from '../Components/ButtonExport'
import { ButtonDownloadTemplate } from '../Components/ButtonDownloadTemplate'
import { ButtonImport } from '../Components/ButtonImport'

type Props = {
  className: string
}

const ApprovalContract: React.FC<Props> = ({className}) => {
  const {roleId} = useAppSelector(authSelector)
  const {filterContractLevel} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const hakAkses = HakAkses()

  const {
    isLoadingEditButton,
    onInitializeLoaderList,
    onResetLoaderList,
    onUpdateLoaderListByIndex,
  } = useLoaderList()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 9,
    onReloadTable: () => handleReloadTable(),
  })

  const [showAdd, setShowAdd] = useState(false)
  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)

  const {t} = useTranslation()

  const [loading, setLoading] = useState(true)
  const [btnLoading, setBtnLoading] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [approvalContract, setApprovalContract] = useState<any>([])
  const [fullSektor, setFullSektor] = useState([])
  const [fullSales, setFullSales] = useState([])
  const [fullPayment, setFullPayment] = useState([])
  const [fullType, setFullType] = useState([])
  const [isError, setIsError] = useState(false)

  const [sales, setSales] = useState('')
  const [sektor, setSektor] = useState(0)
  const [min, setMin] = useState(0)
  const [max, setMax] = useState(0)
  const [level, setLevel] = useState(0)
  const [payment, setPayment] = useState('')
  const [productType, setProductType] = useState('')

  const [tempID, setTempID] = useState(0)

  const [tempData, setTempData] = useState({
    id: 0,
    sales_organization: {name: ''},
    sector: {name: ''},
    payment: {payment_desc: ''},
    product: {product_type: ''},
    min_quantity: 0,
    max_quantity: 0,
    level: 0,
  })

  const paginateNumber = async (url: string) => {
    if (!url) return

    try {
      setLoading(true)

      const endpoint = `${url}&${objToParams(filterContractLevel)}`
      const token = localStorage.getItem('token') as string
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })
      setApprovalContract(res.data.data.data)
      setNumberURL(res.data.data.links)
      onInitializeLoaderList(res.data.data.data)
    } catch (error) {
      setIsError(true)
    } finally {
      setLoading(false)
    }
  }

  const getApprovalContract = async () => {
    setLoading(true)
    await getApproval('contract')
      .then((res) => {
        onInitializeLoaderList(res.data.data.data)
        setApprovalContract(res.data.data.data)
        setNumberURL(res.data.data.links)
        setLoading(false)
      })
      .catch(function (error) {
        setLoading(false)
        if (error.response) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        }
      })
    await getSalesAreaAll().then((res) => {
      setFullSales(res.data.data)
    })
    await getProductType('').then((res) => {
      setFullType(res.data.data)
    })
    await getPaymentAll('?filter=true').then((res) => {
      setFullPayment(res.data.data)
    })
  }

  const [accesses, setAccesses] = useState<any>()

  useEffect(() => {
    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccessesApprovalKo(roleId)

      setLoading(false)
      setAccesses(res.data.data)
    }

    getAccessMenu()
    getApprovalContract()
  }, [])

  const getAllData = async (state: any) => {
    await getSectorAll().then((res) => {
      setFullSektor(res.data.data)
    })

    await getSalesAreaAll().then((res) => {
      setFullSales(res.data.data)
    })

    await getPaymentAll('?filtered=true').then((res) => {
      setFullPayment(res.data.data)
    })

    await getProductType('').then((res) => {
      setFullType(res.data.data)
    })

    state(true)
  }

  const [isCreateButtonLoading, setIsCreateButtonLoading] = useState(false)

  const handleOpenAdd = async () => {
    setIsCreateButtonLoading(true)
    await getAllData(setShowAdd)
    setIsCreateButtonLoading(false)
  }

  const addApproval = async () => {
    setBtnLoading(true)
    const temp = {
      sales_org_code: sales,
      min_quantity: min,
      max_quantity: max,
      level: level,
      sector_id: sektor,
      product_type: productType,
      payment_type: payment,
    }
    await createApproval('contract', temp)
      .then((res) => {
        swal({
          title: t('Approval Level Contract Berhasil di Tambahkan'),
          icon: 'success',
        })
        setShowAdd(false)
        getApprovalContract()
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const handleEdit = async (data: any) => {
    setTempData(data)

    setPayment(data.payment_type)
    setSales(data.sales_org_code)
    setProductType(data.product_type)
    setSektor(data.sector?.id)
    setMin(data.min_quantity)
    setMax(data.max_quantity)
    setLevel(data.level)

    await getAllData(setShowEdit)
    onResetLoaderList()
  }

  const lang = i18next.language

  const updateApproval = async () => {
    setBtnLoading(true)
    const temp = {
      sales_org_code: sales,
      min_quantity: min,
      max_quantity: max,
      level: level,
      sector_id: sektor,
      product_type: productType,
      payment_type: payment,
      lang: lang,
    }
    // console.log(temp)
    await editApproval('contract', tempData.id, temp)
      .then((res) => {
        swal({
          title: t('Approval Level Contract Berhasil di Ubah'),
          icon: 'success',
        })
        setShowEdit(false)
        setActived(!actived)
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const handleDelete = async (id: any) => {
    swal({
      title: t('Are you sure?'),
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteApproval(id)
          .then((res) => {
            swal({
              title: t('Approval Level Contract Berhasil di Hapus'),
              icon: 'success',
            })
            setShowDelete(false)
            setActived(!actived)
            onFetchContractLevel()
          })
          .catch(function (error) {
            if (error.response) {
              swal({
                title: `${error.response.data.message}`,
                icon: 'error',
              })
            }
          })
          .finally(() => {
            setBtnLoading(false)
          })
      }
    })
  }

  const dropApproval = async () => {
    setBtnLoading(true)
    await deleteApproval(tempID)
      .then((res) => {
        swal({
          title: t('Approval Level Contract Berhasil di Hapus'),
          icon: 'success',
        })
        setShowDelete(false)
        setActived(!actived)
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${error.response.data.message}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  CustomUseEffect(() => {
    const salesOrg = document.getElementById('salesOrg') as HTMLSelectElement
    if (salesOrg != null) salesOrg.selectedIndex = 0
    const productType = document.getElementById('productType') as HTMLSelectElement
    if (productType != null) productType.selectedIndex = 0
    const paymentType = document.getElementById('paymentType') as HTMLSelectElement
    if (paymentType != null) paymentType.selectedIndex = 0
    // setPayment('')
    const level = document.getElementById('level') as HTMLInputElement
    if (level != null) level.value = ''
    const minQuantity = document.getElementById('minQuantity') as HTMLInputElement
    if (minQuantity != null) minQuantity.value = ''
    const maxQuantity = document.getElementById('maxQuantity') as HTMLInputElement
    if (maxQuantity != null) maxQuantity.value = ''
    // setRegionCode([])
  }, [sektor])

  const [actived, setActived] = useState(false)

  const onFetchContractLevel = useCallback(() => {
    setLoading(true)
    setIsError(false)
    fetchContractLevels(filterContractLevel)
      .then((res: any) => {
        setApprovalContract(res.data.data.data)
        setNumberURL(res.data.data.links)
        onInitializeLoaderList(res.data.data.data)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filterContractLevel])

  useEffect(() => {
    const getData = setTimeout(onFetchContractLevel, 1000)
    return () => clearTimeout(getData)
  }, [onFetchContractLevel])

  const [language, setLanguage] = useState<any>()
  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const handlePageSizeChange = (value: number | null | undefined) => {
    dispatch(setFilterContractLevel({...filterContractLevel, per_page: value ?? 5}))
  }

  const handleReloadTable = () => {
    dispatch(resetFilterContractLevel())
    onFetchContractLevel()
  }

  useEffect(() => {
    return () => {
      handleReloadTable()
    }
  }, [])

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <SelectPageSize
            initialValue={filterContractLevel?.per_page ?? 5}
            onChange={(value: any) => handlePageSizeChange(value?.value)}
          />
        }
        rightContent={
          <>
            {hakAkses?.create && (
              <>
                  <ButtonExport filter={filterContractLevel} type_approval='contract' />
                  <ButtonDownloadTemplate type_approval='contract' />
                  <ButtonImport onDataImported={() => onFetchContractLevel()} />
                  <AppButton
                    text={
                      <div style={{display: 'flex', alignItems: 'center'}}>
                        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                        {t('order-tambah')}
                      </div>
                    }
                    isLoading={isCreateButtonLoading}
                    disabled={isCreateButtonLoading}
                    onClick={() => handleOpenAdd()}
                  />
              </>
            )}
          </>
        }
      />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <tr>
              <th>ID</th>
              <th>Level</th>
              <th>Sales Org</th>
              <th>{t('Sektor')}</th>
              <th>{t('Payment Type')}</th>
              <th>{t('Product Type')}</th>
              <th>{t('Minimum Quantity')}</th>
              <th>{t('Maximum Quantity')}</th>
              {(hakAkses?.update || hakAkses?.delete) && <th>{t('order-aksi')}</th>}
            </tr>
          </TableUI.THead>
          <TableUI.TBody>
            <RowFilter />
            {loading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : approvalContract.length === 0 ? (
              <RowEmptyData />
            ) : (
              approvalContract.map((data: any, _index: number) => (
                <tr key={data?.id ?? _index}>
                  <td>{data.id}</td>
                  <td>{data.level}</td>
                  <td>{data.sales_organization?.name}</td>
                  <td>{t(data.sector?.name)}</td>
                  {data.payment == null ? (
                    <td>{t('All Payment')}</td>
                  ) : (
                    <td>{data.payment?.payment_desc}</td>
                  )}

                  <td>{data.product?.product_type}</td>
                  <td>
                    {i18next.language === 'en'
                      ? data.min_quantity?.toLocaleString('en', {maximumFractionDigits: 4})
                      : data.min_quantity?.toLocaleString('id', {maximumFractionDigits: 4})}
                  </td>
                  <td>
                    {data.max_quantity === 0
                      ? '~'
                      : i18next.language === 'en'
                      ? data.max_quantity?.toLocaleString('en', {maximumFractionDigits: 4})
                      : data.max_quantity?.toLocaleString('id', {maximumFractionDigits: 4})}
                  </td>
                  {hakAkses?.update || hakAkses?.delete ? (
                    <td>
                      <div className='d-flex flex-shrink-0 justify-content-center'>
                        {hakAkses?.update && (
                          <ActionIcon
                            className='me-2'
                            iconPath='/media/icons/duotune/pencil-fill.svg'
                            title={t('ubah')}
                            isLoading={isLoadingEditButton(_index) ?? false}
                            disabled={isLoadingEditButton(_index) ?? false}
                            onClick={() => {
                              onUpdateLoaderListByIndex(_index)
                              handleEdit(data)
                            }}
                          />
                        )}
                        {hakAkses?.delete && (
                          <button
                            onClick={() => {
                              setTempID(data.id)
                              handleDelete(data.id)
                            }}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('Hapus')}
                          >
                            <KTSVG
                              path='/media/icons/duotune/trash-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        )}
                      </div>
                    </td>
                  ) : (
                    <></>
                  )}
                </tr>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        backdrop='static'
        keyboard={false}
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t('Edit')} {t('Approval')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className='mb-5'>
            <Col sm={4}>
              <h6 className='mt-4'>Sales Org</h6>
            </Col>
            <Col sm={8}>
              <Form.Select
                aria-label='Default select example'
                onChange={(e: any) => setSales(e.target.value)}
              >
                <option selected hidden disabled>
                  {tempData.sales_organization?.name}
                </option>
                {fullSales.map((item: any, index: number) => {
                  return (
                    <option key={item?.code ?? index} value={item.code}>
                      {item.name}
                    </option>
                  )
                })}
              </Form.Select>
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={4}>
              <h6 className='mt-4'>{t('sub-order-sektor')}</h6>
            </Col>
            <Col sm={8}>
              <Form.Select
                aria-label='Default select example'
                onChange={(e: any) => setSektor(parseInt(e.target.value))}
              >
                <option selected hidden disabled>
                  {t(tempData.sector?.name)}
                </option>
                {fullSektor.map((item: any, index: number) => {
                  return (
                    <option key={item?.id ?? index} value={item.id}>
                      {t(item.name)}
                    </option>
                  )
                })}
              </Form.Select>
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={4}>
              <h6 className='mt-4'>{t('Payment Type')}</h6>
            </Col>
            <Col sm={8}>
              <Form.Select
                aria-label='Default select example'
                onChange={(e: any) => setPayment(e.target.value)}
              >
                {tempData?.payment == null ? (
                  <option selected hidden disabled>
                    {t('All Payment')}
                  </option>
                ) : (
                  <option selected hidden disabled>
                    {tempData?.payment?.payment_desc}
                  </option>
                )}
                <option value='all-payment'>{t('All Payment')}</option>
                {fullPayment.map((item: any, index: number) => {
                  return (
                    <option key={item?.code ?? index} value={item.code}>
                      {item.payment_desc}
                    </option>
                  )
                })}
              </Form.Select>
              {/* <Form.Control aria-label="Default select example" placeholder={tempData.payment?.payment_desc} onChange={e => setPayment(e.target.value)} /> */}
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={4}>
              <h6 className='mt-4'>{t('sub-order-jenis')}</h6>
            </Col>
            <Col sm={8}>
              <Form.Select
                aria-label='Default select example'
                onChange={(e: any) => setProductType(e.target.value)}
              >
                <option selected hidden disabled>
                  {t(tempData.product?.product_type)}
                </option>
                {fullType.map((item: any, index: number) => {
                  return (
                    <option key={item?.material_group ?? index} value={item.material_group}>
                      {t(item.material_group_desc)}
                    </option>
                  )
                })}
              </Form.Select>
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={4}>
              <h6 className='mt-4'>Level</h6>
            </Col>
            <Col sm={8}>
              <Form.Control
                type='number'
                placeholder={String(tempData.level)}
                onChange={(e: any) => setLevel(parseInt(e.target.value))}
              />
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={4}>
              <h6 className='mt-4'>{t('Minimum Quantity')}</h6>
            </Col>
            <Col sm={8}>
              <CurrencyInput
                className='form-control form-control-sm'
                defaultValue={tempData.min_quantity}
                decimalSeparator={language === 'en' ? '.' : ','}
                groupSeparator={language === 'en' ? ',' : '.'}
                onValueChange={(value: any) => {
                  setMin(value)
                }}
                decimalsLimit={3}
              />
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={4}>
              <h6 className='mt-4'>{t('Maximum Quantity')}</h6>
            </Col>
            <Col sm={8}>
              <CurrencyInput
                className='form-control form-control-sm'
                defaultValue={tempData.max_quantity}
                decimalSeparator={language === 'en' ? '.' : ','}
                groupSeparator={language === 'en' ? ',' : '.'}
                onValueChange={(value: any) => {
                  setMax(value)
                }}
                decimalsLimit={3}
              />
            </Col>
          </Row>
          <div className='d-flex justify-content-end'>
            <Button variant='primary' onClick={() => updateApproval()} disabled={btnLoading}>
              {btnLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                <>
                  <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                  {t('order-kirim')}
                </>
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showDelete} onHide={() => setShowDelete(false)} centered backdrop='static'>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h3 className='text-center mb-5'>
            {t('Hapus')} {t('Approval')}?
          </h3>
          <div className='d-flex justify-content-center'>
            <Button variant='secondary me-2' onClick={() => setShowDelete(false)}>
              {t('Tidak')}
            </Button>
            <Button variant='danger' onClick={() => dropApproval()} disabled={btnLoading}>
              {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('Ya')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showAdd}
        onHide={() => setShowAdd(false)}
        backdrop='static'
        keyboard={false}
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t('order-tambah')} {t('Approval')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isCreateButtonLoading ? (
            <SkeletonForm />
          ) : (
            <>
              <Row className='mb-5'>
                <Col sm={4}>
                  <h6 className='mt-4'>{t('sub-order-sektor')}</h6>
                </Col>
                <Col sm={8}>
                  <Form.Select
                    id='sektor'
                    aria-label='Default select example'
                    onChange={(e: any) => setSektor(parseInt(e.target.value))}
                  >
                    <option selected hidden disabled>
                      {t('Sektor')}
                    </option>
                    {fullSektor.map((item: any, index: number) => {
                      return (
                        <option key={item?.id ?? index} value={item.id}>
                          {t(item.name)}
                        </option>
                      )
                    })}
                  </Form.Select>
                </Col>
              </Row>
              <Row className='mb-5'>
                <Col sm={4}>
                  <h6 className='mt-4'>Sales Org</h6>
                </Col>
                <Col sm={8}>
                  <Form.Select
                    id='salesOrg'
                    aria-label='Default select example'
                    onChange={(e: any) => setSales(e.target.value)}
                  >
                    <option selected hidden disabled>
                      Sales Org
                    </option>
                    {fullSales.map((item: any, index: number) => {
                      return (
                        <option key={item?.code ?? index} value={item.code}>
                          {item.name}
                        </option>
                      )
                    })}
                  </Form.Select>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col sm={4}>
                  <h6 className='mt-4'>{t('Payment Type')}</h6>
                </Col>
                <Col sm={8}>
                  <Form.Select
                    id='paymentType'
                    aria-label='Default select example'
                    onChange={(e: any) => setPayment(e.target.value)}
                  >
                    <option selected hidden disabled>
                      {t('Payment Type')}
                    </option>
                    <option value='all-payment'>{t('All Payment')}</option>
                    {fullPayment.map((item: any, index: number) => {
                      return (
                        <option key={item?.code ?? index} value={item.code}>
                          {item.payment_desc}
                        </option>
                      )
                    })}
                  </Form.Select>
                  {/* <Form.Control aria-label="Default select example" placeholder='Payment type' onChange={e => setPayment(e.target.value)} /> */}
                </Col>
              </Row>
              <Row className='mb-5'>
                <Col sm={4}>
                  <h6 className='mt-4'>{t('sub-order-jenis')}</h6>
                </Col>
                <Col sm={8}>
                  <Form.Select
                    id='productType'
                    aria-label='Default select example'
                    onChange={(e: any) => setProductType(e.target.value)}
                  >
                    <option selected hidden disabled>
                      {t('Product Type')}
                    </option>
                    {fullType.map((item: any, index: number) => {
                      return (
                        <option key={item?.material_group ?? index} value={item.material_group}>
                          {t(item.material_group_desc)}
                        </option>
                      )
                    })}
                  </Form.Select>
                </Col>
              </Row>
              <Row className='mb-5'>
                <Col sm={4}>
                  <h6 className='mt-4'>Level</h6>
                </Col>
                <Col sm={8}>
                  <Form.Control
                    id='level'
                    type='number'
                    placeholder={t('Level Approval')}
                    onChange={(e: any) => setLevel(parseInt(e.target.value))}
                  />
                </Col>
              </Row>
              <Row className='mb-5'>
                <Col sm={4}>
                  <h6 className='mt-4'>{t('Minimum Quantity')}</h6>
                </Col>
                <Col sm={8}>
                  <CurrencyInput
                    key={sektor}
                    className='form-control form-control-sm'
                    placeholder={t('Minimum Quantity')}
                    decimalSeparator={language === 'en' ? '.' : ','}
                    groupSeparator={language === 'en' ? ',' : '.'}
                    onValueChange={(value: any) => {
                      setMin(value)
                    }}
                    decimalsLimit={3}
                  />
                </Col>
              </Row>
              <Row className='mb-5'>
                <Col sm={4}>
                  <h6 className='mt-4'>{t('Maximum Quantity')}</h6>
                </Col>
                <Col sm={8}>
                  <CurrencyInput
                    key={sektor}
                    className='form-control form-control-sm'
                    placeholder={t('Maximum Quantity')}
                    decimalSeparator={language === 'en' ? '.' : ','}
                    groupSeparator={language === 'en' ? ',' : '.'}
                    onValueChange={(value: any) => {
                      setMax(value)
                    }}
                    decimalsLimit={3}
                  />
                </Col>
              </Row>
              <div className='d-flex justify-content-end'>
                <Button variant='primary' onClick={() => addApproval()} disabled={btnLoading}>
                  {btnLoading ? (
                    <Spinner animation='border' variant='light' size='sm' />
                  ) : (
                    <>
                      <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                      {t('order-kirim')}
                    </>
                  )}
                </Button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {ApprovalContract}
